import { get } from 'lodash'
export default function getPhoneNumber (user) {
  const phones = get(user, 'user_info.profile.contacts.communication.phone', [])
  const primaryPhone = phones.find(phone => phone.category === 'primary' || phone.category === 'secondary' || phone.category === 'mobile' || phone.category === 'work' || phone)
  const primaryPhoneValue = primaryPhone ? primaryPhone.value : ''
  return primaryPhoneValue
}

export function getPhoneNumbers (user) {
  const phoneNumbers = get(user, 'profile.contacts.communication.phone', [])
  if (phoneNumbers && phoneNumbers.length) {
    return phoneNumbers.reduce((str, number, index) => {
      if (index) {
        str += ' ,'
      }
      str += number.value
      return str
    }, '')
  }
  return null
}
